module.exports = __webpack_public_path__ + "img/SKMJ_cap4.94ac31b2.jpg";